import React, { useState, useEffect } from "react";
import { notify } from '../utils/alertBus';

const ExpenseModal = ({ expense, onClose, onSave }) => {
  const [form, setForm] = useState({
    amount: "",
    description: "",
    date: new Date().toISOString().slice(0, 10),
    paymentMethod: "efectivo",
  });

  useEffect(() => {
    if (expense) {
      setForm({
        ...expense,
        date: expense.date.slice(0, 10), // format yyyy-mm-dd
      });
    }
  }, [expense]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!form.amount || !form.description) {
      notify("Todos los campos son requeridos");
      return;
    }
    onSave(form);
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-start justify-center z-50 px-4 py-6 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-2xl shadow-2xl border border-gray-100 overflow-hidden max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between px-6 py-4 border-b border-gray-100 bg-gray-50">
          <div>
            <p className="text-xs uppercase tracking-wide text-gray-500">Gastos</p>
            <h2 className="text-lg font-semibold text-gray-900">{expense ? "Editar" : "Nuevo"} gasto</h2>
            <p className="text-xs text-gray-500 mt-1">Registra un gasto operativo para esta sucursal.</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-900 bg-white border border-gray-200 rounded-full w-9 h-9 flex items-center justify-center"
          >
            ✕
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div>
            <label className="text-xs font-semibold text-gray-600 uppercase">Descripción</label>
            <input
              type="text"
              name="description"
              value={form.description}
              onChange={handleChange}
              className="mt-2 w-full border border-gray-300 rounded-lg p-2"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase">Monto</label>
              <input
                type="number"
                name="amount"
                value={form.amount}
                onChange={handleChange}
                className="mt-2 w-full border border-gray-300 rounded-lg p-2"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-gray-600 uppercase">Fecha</label>
              <input
                type="date"
                name="date"
                value={form.date}
                onChange={handleChange}
                className="mt-2 w-full border border-gray-300 rounded-lg p-2"
              />
            </div>
          </div>

          <div>
            <label className="text-xs font-semibold text-gray-600 uppercase">Método de pago</label>
            <select
              name="paymentMethod"
              value={form.paymentMethod}
              onChange={handleChange}
              className="mt-2 w-full border border-gray-300 rounded-lg p-2"
            >
              <option value="efectivo">Efectivo</option>
              <option value="transferencia">Transferencia</option>
              <option value="tarjeta">Tarjeta</option>
              <option value="cheque">Cheque</option>
            </select>
          </div>

          <div className="flex items-center justify-between border-t border-gray-100 pt-4">
            <div className="text-xs text-gray-500">
              Todos los campos son obligatorios.
            </div>
            <div className="flex gap-2">
              <button onClick={onClose} className="px-4 py-2 rounded-lg border border-gray-200 text-gray-700 hover:text-gray-900">
                Cancelar
              </button>
              <button onClick={handleSubmit} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpenseModal;
